$(document).ready(function() {
    $(document).on('click', '.btn-engagement-rings', function() {
        var ringSizeSelect = $('.custom-select');
           // console.log(ringSizeSelect.val(),"ringSizeSelect")
        if (ringSizeSelect.val() == null) {
            // alert("Please select a ring size.");
            
        } else {
            setTimeout(function() {
                $('#myModal').fadeIn(); // Use fadeIn for a smoother effect
            }, 4000);
        }
    });
      $(document).on('click', '.btnColle-engagement-rings', function() {
            setTimeout(function() {
                $('#myModal').fadeIn(); 
            }, 4000);
    });
    $(document).on('click', '.close', function() {
        $('#myModal').fadeOut(); // Fade out the modal when closing
    });
});
